// Per-service configuration for landing pages.
// Each entry powers a separate URL with its own hero copy + SEO.
// The rest of the page (packages, testimonials, reviews, case studies, contact, footer) is shared.

export const HOME_SERVICE = {
  slug: "/",
  hero: {
    eyebrow: "The UK's AI-powered career platform",
    headline: ["Where Professional CV Writing", "Meets AI."],
    headlineHighlight: "Meets AI.",
    sub: "Create an ATS-friendly CV using AI built around professional CV writing methodology, or work directly with experienced UK CV writers for a fully personalised CV.",
  },
  whyUs: {
    eyebrow: "Why CV Folks",
    headline: "Built for career growth — not just your next job.",
    sub: "Every CV we write is engineered to position you for the next step in your career — higher seniority, higher pay, and roles that match your ambition.",
  },
  whyInvest: {
    eyebrow: "What's included",
    headline: ["What you get", "with every order."],
    headlineHighlight: "with every order.",
  },
  seo: {
    title:
      "Professional CV Writing & AI CV Builder UK | CV Folks Britain",
    description:
      "Build a CV with AI for £9.99 or hire a UK professional CV writer from £50. The UK's AI career platform — ATS-friendly CVs, 60-day interview guarantee.",
    keywords:
      "ai cv builder, cv writing service, professional cv writer, cv writer, ai cv maker, cv builder, cv maker, resume writer, ats cv builder, cv creator, cv help, cv writing service uk, cv writing service london, cover letter writing, linkedin profile writing, cv folks",
  },
};

export const EXECUTIVE_CV_SERVICE = {
  slug: "/executive-cv-writing-service",
  hero: {
    eyebrow: "Executive CV Writing Service",
    headline: ["Executive CVs that win", "boardroom interviews."],
    headlineHighlight: "boardroom interviews.",
    sub: "Strategic, board-ready CVs, cover letters and LinkedIn profiles written by senior executive CV writers — for directors, VPs and C-suite leaders. Backed by our 60-Day Interview Guarantee.",
  },
  whyUs: {
    eyebrow: "Why senior leaders choose CV Folks",
    headline: "Built for the next level of leadership.",
    sub: "Every executive CV is engineered to position you for board, director and senior-leadership roles — translating impact into the language hiring committees expect.",
  },
  whyInvest: {
    eyebrow: "The case for investing",
    headline: ["Why invest in an", "executive CV writer?"],
    headlineHighlight: "executive CV writer?",
  },
  seo: {
    title: "Executive CV Writing Service UK | Executive CV Writer | CV Folks",
    description:
      "Executive CV writing service for senior leaders, directors and C-suite. UK-based executive CV writers crafting board-ready CVs, cover letters and LinkedIn profiles. 60-Day Interview Guarantee.",
    keywords:
      "executive cv writing service, executive cv writer, senior cv writing service, c-suite cv, director cv writing, executive resume writer uk, board level cv writing, leadership cv writer, senior executive cv writing, cv folks",
  },
};

export const SERVICES = {
  "/": HOME_SERVICE,
  "/executive-cv-writing-service": EXECUTIVE_CV_SERVICE,
};
